module.exports = __webpack_public_path__ + "static/media/enter.c15871f8.svg";